import { useRouter } from 'next/router';
import Image from 'components/shared/image';
import { addLocaleToHref } from 'lib/utils/helpers';
import styles from './dashboardSection.module.scss';

const DashboardSection = ({
  locale,
  accountpagenavigation,
  dashboardaccountpage,
  setNavTracker,
  subscriptionsLink,
}) => {
  const router = useRouter();
  const {
    navigationDashboard,
    navigationOrders,
    navigationPersonalInfo,
    navigationAddressBook,
    navigationSubscriptions,
  } = accountpagenavigation;

  const {
    actionButtonContent,
    addressBookBoxContent,
    contactUsBoxContent,
    contactUsBoxImage,
    contactUsBoxTitle,
    ordersBoxContent,
    personalInfoBoxContent,
    subscriptionsBoxContent,
  } = dashboardaccountpage;

  return (
    <>
      <h1 className={styles.title}>{navigationDashboard?.text}</h1>
      <div className={styles.optionsContainer}>
        <div className={styles.orders}>
          <h2 className={styles.optionsTitle}>{navigationOrders?.text}</h2>
          <span className={styles.description}>{ordersBoxContent?.text}</span>
          <button
            className={styles.action}
            type="button"
            onClick={() => {
              router.push(addLocaleToHref(`/account/orders/`, locale), undefined, {
                shallow: true,
              });
            }}
          >
            {actionButtonContent?.text}
          </button>
        </div>
        <div className={styles.personalInfo}>
          <h2 className={styles.optionsTitle}>{navigationPersonalInfo?.text}</h2>
          <span className={styles.description}>{personalInfoBoxContent?.text}</span>
          <button
            className={styles.action}
            type="button"
            onClick={() => {
              router.push(addLocaleToHref(`/account/personalInfo/`, locale), undefined, {
                shallow: true,
              });
            }}
          >
            {actionButtonContent?.text}
          </button>
        </div>
        <div className={styles.addresses}>
          <h2 className={styles.optionsTitle}>{navigationAddressBook?.text}</h2>
          <span className={styles.description}>{addressBookBoxContent?.text}</span>
          <button
            className={styles.action}
            type="button"
            onClick={() => {
              router.push(addLocaleToHref(`/account/addressBook/`, locale), undefined, {
                shallow: true,
              });
            }}
          >
            {actionButtonContent?.text}
          </button>
        </div>
        {subscriptionsLink && (
          <div className={styles.addresses}>
            <h2 className={styles.optionsTitle}>{navigationSubscriptions?.text}</h2>
            <span className={styles.description}>{subscriptionsBoxContent?.text}</span>
            <a className={styles.action} href={subscriptionsLink}>
              {actionButtonContent?.text}
            </a>
          </div>
        )}
        <div className={styles.contactBox}>
          <Image
            src={contactUsBoxImage?.image || contactUsBoxImage?.media?.[0]?.image}
            layout="fill"
            className={styles.image}
          />
          <h3 className={styles.imageTitle}>{contactUsBoxTitle?.text}</h3>
          <span className={styles.imageTagline}>{contactUsBoxContent?.text}</span>
        </div>
      </div>
    </>
  );
};

export default DashboardSection;
